import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@shared/interceptor/auth.interceptor';
import { UiToastService } from '@shared/components/ui';
import { baseUrlInterceptor } from '@shared/interceptor/base-url.interceptor';
import { sucursalInterceptor } from '@shared/interceptor/sucursal.interceptor';
import { authInitializer } from '@core/initializers/auth.initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideHttpClient(
      withFetch(),
      withInterceptors([baseUrlInterceptor, authInterceptor, sucursalInterceptor]),
    ),
    UiToastService,
    provideAppInitializer(authInitializer),
  ],
};
